var _actionData;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// tslint:disable max-line-length
import { ACCOUNT_ACTION_IDS, ACCOUNT_EVENT_IDS, AccountActionTypes } from '@central-products/interface-account-actions';
export var actionData = (_actionData = {}, _defineProperty(_actionData, ACCOUNT_EVENT_IDS.DEPOSIT_REQUIRED, {
  actionId: ACCOUNT_ACTION_IDS.DEPOSIT_START,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data',
  defaultData: 'https://sports.williamhill{env}.com/{obDevice}/{obLang}/payment/deposit/{depositHtmlPage}.html?hide_header=1&source={regSource}'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.RECOVER_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.RECOVER_START,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data',
  defaultData: 'https://myaccount.williamhill{env}.com/recovery/{lang}?closeBtn=false'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.REOPEN_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.REOPEN_START,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data',
  defaultData: 'https://myaccount.williamhill{env}.com/recovery/reopen/{lang}?closeBtn=false'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.RESET_PASSWORD_REQUIRED, {
  actionId: ACCOUNT_ACTION_IDS.RESET_PASSWORD_START,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data',
  defaultData: 'https://sports.williamhill{env}.com/{obDevice}/{lang}?action=GoUpdatePwd&modal_reg=0&target_page='
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.FAQ_PAGE_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.FAQ_PAGE_OPEN,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.LIVE_CHAT_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.LIVE_CHAT_OPEN,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.LOGIN_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.LOGIN_START,
  actionType: AccountActionTypes.USER_FLOW,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.REGISTRATION_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.REGISTRATION_START,
  actionType: AccountActionTypes.USER_FLOW,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.API_CALL_INVALID, {
  actionId: ACCOUNT_ACTION_IDS.MESSAGE_LOG,
  actionType: AccountActionTypes.DEBUG_MESSAGE
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.INVALID_STATE, {
  actionId: ACCOUNT_ACTION_IDS.MESSAGE_LOG,
  actionType: AccountActionTypes.DEBUG_MESSAGE
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.OPERATION_FAILED, {
  actionId: ACCOUNT_ACTION_IDS.MESSAGE_LOG,
  actionType: AccountActionTypes.DEBUG_MESSAGE
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPEN,
  actionType: AccountActionTypes.USER_FLOW,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_CAMPAIGN_DISPLAYED, {
  actionId: ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_CAMPAIGN_DISPLAYED,
  actionType: AccountActionTypes.USER_FLOW,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_NAVIGATE_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.NAVIGATE_TO,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.BETSLIP_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.OPEN_BETSLIP,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.PLACE_BET_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.PLACE_BET,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data'
}), _defineProperty(_actionData, ACCOUNT_EVENT_IDS.LAUNCH_GAME_REQUESTED, {
  actionId: ACCOUNT_ACTION_IDS.LAUNCH_GAME,
  actionType: AccountActionTypes.REDIRECT,
  pathToData: 'data'
}), _actionData);
//# sourceMappingURL=actionData.js.map